<mat-toolbar class="app-toolbar">

  <span><mat-icon class="icon">{{toolbarIcon$ | async}}</mat-icon> <span class="title">{{toolbarTitle$ | async}}</span></span>

  <span class="spacer"></span>

  <button class="toolbar-menu-button big-screen-hide" mat-button [matMenuTriggerFor]="smallNavMenu">
    <span class="button-content">
      <mat-icon>{{currentNavIcon}}</mat-icon>
      <mat-icon class="dropdown-arrow">arrow_drop_down</mat-icon>
    </span>
  </button>

  <mat-menu #smallNavMenu class="small-nav-menu">
    <button mat-menu-item class="menu-button" routerLink="/main/dashboard" *ngIf="permissionService.isAllowed('viewDashboard') | async" (click)="changeNavIcon('dashboard')"> <mat-icon>dashboard</mat-icon><span>{{ 'NAVBAR.DASHBOARD' | translate }}</span></button>
    <button mat-menu-item class="menu-button" routerLink="/main/equipments" *ngIf="permissionService.isAllowed('listEquipments') | async" (click)="changeNavIcon('memory')"> <mat-icon>memory</mat-icon><span>{{ 'NAVBAR.EQUIPMENT' | translate }}</span></button>
    <button mat-menu-item class="menu-button" routerLink="/main/remotes" *ngIf="!(permissionService.isAllowed('acmDisabled') | async)" (click)="changeNavIcon('settings_remote')"> <mat-icon>settings_remote</mat-icon><span>{{ 'NAVBAR.REMOTES' | translate }}</span></button>
    <button mat-menu-item class="menu-button" routerLink="/main/accounts" *ngIf="permissionService.isAllowed('getAccounts') | async" (click)="changeNavIcon('admin_panel_settings')"> <mat-icon>admin_panel_settings</mat-icon><span>{{ 'NAVBAR.ACCOUNTS' | translate }}</span></button>
    <button mat-menu-item class="menu-button" routerLink="/main/members" *ngIf="permissionService.isAllowed('listUsers') | async" (click)="changeNavIcon('supervisor_account')"> <mat-icon>supervisor_account</mat-icon><span>{{ 'NAVBAR.USERS' | translate }}</span></button>
    <button mat-menu-item class="menu-button" routerLink="/main/dealers" *ngIf="permissionService.isAllowed('listSubDealers') | async" (click)="changeNavIcon('domain')"> <mat-icon>domain</mat-icon><span>{{ 'NAVBAR.DEALERS' | translate }}</span></button>
    <button mat-menu-item class="menu-button" routerLink="/main/advanced" *ngIf="(hasAnyAdvancedReadPermission() | async)" (click)="changeNavIcon('settings')"> <mat-icon>settings</mat-icon><span>{{ 'NAVBAR.ADVANCED' | translate }}</span></button>
  </mat-menu>

  <button class="toolbar-menu-button" mat-button [matMenuTriggerFor]="dealersMenu" *ngIf="currentUserDealers.length > 1">
    <span class="button-content">
      <mat-icon>domain</mat-icon>
      <span class="menu-text"> {{currentUserDealerName$ | async}}</span>
      <mat-icon class="dropdown-arrow">arrow_drop_down</mat-icon>
    </span>
  </button>

  <mat-menu #dealersMenu>
    <button class="menu-button" mat-menu-item *ngFor="let dealer of currentUserDealers" (click)="changeUserDealer(dealer.id)">
      <mat-icon>domain</mat-icon>{{dealer.name}}
    </button>
  </mat-menu>

  <button class="toolbar-menu-button" mat-button [matMenuTriggerFor]="userMenu">
    <span class="button-content">
      <mat-icon>person</mat-icon>
      <span class="menu-text">{{currentUserName$ | async}}</span>
      <mat-icon class="dropdown-arrow">arrow_drop_down</mat-icon>
    </span>
  </button>
  <mat-menu #userMenu>
    <button class="menu-button" mat-menu-item routerLink="/main/profile/user"><mat-icon>info</mat-icon>{{ 'NAVBAR.PROFILE' | translate }}</button>
    <button class="menu-button" mat-menu-item routerLink="/main/profile/dealer"><mat-icon>domain</mat-icon>{{ 'NAVBAR.MY_DEALER' | translate }}</button>
    <hr>
    <button class="menu-button" mat-menu-item routerLink="/login" (click)="logout()"><mat-icon>logout</mat-icon>{{ 'NAVBAR.LOGOUT' | translate }}</button>
  </mat-menu>

  <!-- <button mat-icon-button [matMenuTriggerFor]="notificationsMenu" class="notification-button"><mat-icon>notifications</mat-icon></button>
  <mat-menu #notificationsMenu>
    <span class="notification-item">{{ 'NAVBAR.NO_NOTIFICATIONS' | translate }}</span>
  </mat-menu> -->

</mat-toolbar>